import * as React from 'react';
import IconBase, { IconBaseProps } from '../components/Icons/IconBase';
const props = {};

const SvgQuestion = (allProps: IconBaseProps) => {
  return (
    <IconBase {...allProps}>
      <svg
        width="1em"
        height="1em"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
      >
        <path
          d="M9.33337 9.33327C9.33347 8.84441 9.46794 8.36498 9.7221 7.94738C9.97627 7.52978 10.3403 7.19008 10.7745 6.96541C11.2087 6.74074 11.6963 6.63975 12.184 6.67347C12.6717 6.70719 13.1407 6.87432 13.5398 7.1566C13.939 7.43889 14.2528 7.82546 14.4471 8.27406C14.6414 8.72267 14.7086 9.21604 14.6414 9.70027C14.5742 10.1845 14.3752 10.6409 14.0661 11.0197C13.7571 11.3985 13.3498 11.685 12.8889 11.8479C12.6289 11.9399 12.4037 12.1102 12.2445 12.3355C12.0853 12.5608 11.9999 12.8299 12 13.1057V13.9999"
          stroke="currentColor"
          strokeWidth={1.25}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M12 16.6667C11.934 16.6667 11.8696 16.6862 11.8148 16.7228C11.76 16.7595 11.7172 16.8115 11.692 16.8724C11.6668 16.9333 11.6602 17.0004 11.673 17.065C11.6859 17.1297 11.7176 17.1891 11.7643 17.2357C11.8109 17.2823 11.8703 17.3141 11.9349 17.3269C11.9996 17.3398 12.0666 17.3332 12.1275 17.3079C12.1884 17.2827 12.2405 17.24 12.2771 17.1852C12.3137 17.1304 12.3333 17.0659 12.3333 17C12.3333 16.9116 12.2982 16.8268 12.2357 16.7643C12.1731 16.7018 12.0884 16.6667 12 16.6667Z"
          fill="currentColor"
          stroke="currentColor"
          strokeWidth={1.25}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M2 12C2 14.6522 3.05357 17.1957 4.92893 19.0711C6.8043 20.9464 9.34784 22 12 22C14.6522 22 17.1957 20.9464 19.0711 19.0711C20.9464 17.1957 22 14.6522 22 12C22 9.34784 20.9464 6.8043 19.0711 4.92893C17.1957 3.05357 14.6522 2 12 2C9.34784 2 6.8043 3.05357 4.92893 4.92893C3.05357 6.8043 2 9.34784 2 12V12Z"
          stroke="currentColor"
          strokeWidth={1.25}
        />
      </svg>
    </IconBase>
  );
};

SvgQuestion.displayName = 'SvgQuestion';
export default SvgQuestion;
